<div
  [ngClass]="{
    'ic__markup__container': true,
    'ic__markup__container--valid': data.state === 0 && !data.disabled,
    'ic__markup__container--invalid': data.state === 1 && !data.disabled,
    'ic__markup__container--active': data.state === 2 && !data.disabled,
    'ic__markup__container--inactive': data.state === 3 && !data.disabled,
    'ic__markup__container--locked': data.disabled || locked
  }"
>
  <div [bfx-input]="bfxInput" [ngClass]="inputDirective.classes" #input>
    <div class="bfx-input-label">
      <p-checkbox
        #chkBox
        [bfxInputLabelOnClick]="chkBoxLabel"
        binary="true"
        class="ic__markup__checkbox bfx-checkbox-enable-control"
        [disabled]="input_disabled || data.disabled || locked"
        [(ngModel)]="data.markup.checkbox.value"
        (onChange)="onMarkupCheckboxChange($event)"
      >
      </p-checkbox>
      <div #chkBoxLabel [ngClass]="inputDirective.labelClasses">{{data.label}}</div>
      <div
        class="ic__markup__rate__label"
        [ngClass]="inputDirective.labelClasses"
        *ngIf="!hideTrackingRate"
        title="{{data.trackingTooltip}} {{data.clientTooltip}}"
      >
        {{data.trackingData}} {{data.clientData}}
      </div>
    </div>
  </div>
  <!-- <div class="ic__markup__checkbox__container">
    
  </div> -->

  <div
    class="ic__markup__controls__wrapper"
    [style.display]="!data.markup.checkbox.value ? 'none': 'flex'"
  >
    <number-spinner
      #markup_spinner
      class="order-entry__panel-financials__markup-amount"
      inputId="markup"
      [min]="data.min"
      [max]="data.max"
      [disabled]="data.disabled || input_disabled || locked"
      [locked]="locked"
      stepType="CONSTANT"
      [step]="data.step"
      [label]=""
      [minPrecision]="data.precision"
      [maxPrecision]="data.precision"
      [showValidationBar]="false"
      [externalState]="externalState"
      (change)="onChange()"
      (focus)="onStepperFocus()"
      (blur)="onStepperBlur()"
      [size]="'sm'"
    >
    </number-spinner>
    <!-- </div> -->
    <!-- ic__markup-spinner__container -->

    <!-- <div class="ui-float-label ic__markup__type__container"> -->
    <div class="order-entry__panel-financials__markup-type_container">
      <bfx-autoComplete
        #inputMarkupType
        delay="5"
        field="label"
        dataKey="value"
        class="order-entry__panel-financials__markup-type"
        [allowEmptySelection]="true"
        [emptyIsInactive]="true"
        [state]="locked ? 3 : data.state"
        [disabled]="input_disabled || data.disabled || locked"
        [(ngModel)]="markupType"
        [suggestions]="data.filteredTypeDataset"
        [skipSorting]="true"
        [dropdown]="true"
        [label]="''"
        [minLength]="0"
        [maxlength]="50"
        [appendTo]="'body'"
        (completeMethod)="lookupMarkupType($event)"
        (onFocus)="onTypeFocus($event)"
        (onSelect)="onSelectMarkupType($event)"
        (onBlur)="onTypeBlur($event)"
        [appendTo]="'body'"
        [size]="'sm'"
      >
      </bfx-autoComplete>
      <!-- </div> -->
      <!-- ic__markup__type__container -->
      <button
        *ngIf="data.showRefresh"
        class="bfx-icon-button-secondary-subtle-unsized bfx-icon-button-sm"
        type="button"
        tabindex="-1"
        (click)="retrieveMarkup($event)"
        [disabled]="input_disabled || data.disabled || locked || !this.data.retrieveMarkupEnabled"
        [ngClass]="{
        'disabled': input_disabled || data.disabled || locked,
        'ic__markup__button__markup-refresh--inactive': data.state === 3 && showValidationBar && !locked
      }"
      >
        <i class="icon-refresh"></i>
      </button>
    </div>
  </div>
</div>
<!-- ic__markup__container -->
